import { Component, Injector, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicationContextService } from 'src/app/services/application-context.service';

@Component({
    selector: 'tpo-appraisal-management',
    templateUrl: 'tpo-appraisal-management.component.html',
    standalone: false
})
export class TpoAppraisalManagementComponent implements OnDestroy {

  isTpo: boolean = false;

  private readonly _contextSubscription: Subscription;

  constructor(private readonly injector: Injector,
    private readonly _applicationContextService: ApplicationContextService) {

    this._contextSubscription = this._applicationContextService.context.subscribe(context => {
      this.isTpo = context.isTpo;
    });
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this._contextSubscription?.unsubscribe();
  }
}
